// ** Third Party Components
import { Bell } from "react-feather"
import { useTranslation } from "react-i18next"

// ** Reactstrap Imports
import { UncontrolledDropdown, DropdownMenu, DropdownToggle } from "reactstrap"

// ** Campana del header.
//
// El rediseño la dibuja como un botón cuadrado con borde, pero no le da comportamiento:
// en el archivo de diseño es un placeholder sin onClick. Publicar un control que no hace
// nada al pulsarlo sería peor que no publicarlo, así que aquí abre un dropdown con estado
// vacío. Queda como el punto de enganche para cuando exista la fuente de notificaciones.
//
// Ojo: src/@core/components/notifications no sirve para esto. Es un envoltorio del Store
// de react-notifications-component, es decir un helper de toasts, no un buzón.
const NotificationsBell = () => {
  const { t } = useTranslation()

  return (
    <UncontrolledDropdown tag="div" className="dropdown-notification">
      <DropdownToggle
        tag="button"
        type="button"
        className="bp-header-btn bp-header-btn--icon"
        aria-label={t("Notifications")}
      >
        <Bell size={18} />
      </DropdownToggle>
      <DropdownMenu end className="mt-0">
        <div className="px-1 py-2 text-center text-muted" style={{ minWidth: "220px" }}>
          {t("NoNotifications")}
        </div>
      </DropdownMenu>
    </UncontrolledDropdown>
  )
}

export default NotificationsBell
